import { useScopedOrderView } from '@plf/utils/useOrderView'

export function useCalendarState() {
  const route = useRoute()

  return useScopedOrderView(`calendar:${route.path}`)
}
